(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-no-charity-card.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/react/components/select-no-charity-card.js');

'use strict';

const _React = React,
  useEffect = _React.useEffect;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardHeader = _svs$ui$ReactCard.CardHeader,
  CardExpandableBody = _svs$ui$ReactCard.CardExpandableBody;
const Button = svs.ui.ReactButton;
const track = action => {
  svs.components.analytics.trackEvent({
    category: 'Lyckoplatsen',
    action,
    opt_label: '/lyckoplatsen/relaterat'
  });
};
const SelectNoCharityCard = () => {
  const history = ReactRouterDOM.useHistory();
  const _ReactRouterDOM$usePa = ReactRouterDOM.useParams(),
    wagerId = _ReactRouterDOM$usePa.wagerId;
  const handleClick = wagerId => {
    track('Avstår vgho');
    history.replace("/relaterat/".concat(wagerId, "/0"));
  };
  useEffect(() => {
    const elements = document.querySelectorAll('.lp-charity-card-header-flik');
    const handleDeclineClick = () => {
      track('flik');
    };
    elements.forEach(el => el.addEventListener('click', handleDeclineClick));
    return () => {
      elements.forEach(el => el.removeEventListener('click', handleDeclineClick));
    };
  }, []);
  return React.createElement("div", {
    className: "lp-charity-card f-content"
  }, React.createElement(Card, {
    expandable: true
  }, React.createElement(CardHeader, {
    className: "lp-charity-card-header-flik"
  }, React.createElement("div", {
    className: "card-charity-header-content"
  }, React.createElement("p", {
    className: "h3"
  }, "Vad h\xE4nder om jag inte v\xE4ljer?"))), React.createElement(CardExpandableBody, null, React.createElement("p", {
    className: "align-left padding-h-1"
  }, "\xC4ven om du avst\xE5r fr\xE5n att v\xE4lja en organisation s\xE5 bidrar du till bra saker. F\xF6r n\xE4r du spelar hos Svenska Spel s\xE5 g\xE5r din vinst till dig och v\xE5r vinst tillbaka till samh\xE4llet. Din insats g\xF6r med andra ord alltid en insats f\xF6r n\xE5got st\xF6rre."), React.createElement(Button, {
    transparent: true,
    onClick: () => handleClick(wagerId),
    className: "margin-bottom-1"
  }, "Jag avst\xE5r fr\xE5n att v\xE4lja"))));
};
setGlobal('svs.lyckoplatsen.components.shared_charity.react.components', {
  SelectNoCharityCard
});

 })(window);